<template>
    <div class="order_item-wrap">
        <div class="order_item-thumb">
            <van-image
                width="2rem"
                height="2rem"
                fit="cover"
                :src="commodityInfo.site_info.image_src"
				round
            />
        </div>
        <div class="order_item-content">
            <div class="order_item-site">
                <span>{{commodityInfo.site_info ? commodityInfo.site_info.name : ''}}</span>
            </div>
            <div class="order_item-gun_num">
                <van-tag class="base-theme-tag round">{{commodityInfo.detail.site_oil_gun_info ? commodityInfo.detail.site_oil_gun_info.name : ''}}号枪</van-tag>
            </div>
        </div>
        <div class="order_item-cost" v-if="showCost">
            <div class="order_item-price">¥{{commodityInfo.detail.oil_price}}</div>
            <div class="order_item-count">x{{commodityInfo.detail.oil_liter}}L</div>
        </div>
    </div>
</template>

<script>
    import '../../assets/icon/iconfont'

    export default {
        name: 'CommodityCard',
        props: {
            commodityInfo: {
                type: Object,
                default () {
                    return {
                        detail :{
                            site_oil_gun_info : {},
                        },
                    }
                }
            },
            showCost: {
                type: Boolean,
                default () {
                    return true
                }
            }
        },
        data () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    .order_item-wrap {
        display: flex;
        align-items: flex-start;

        .order_item-thumb {
        }

        .order_item-content {
            flex: 1;
            margin: 0 15px;

            .order_item-site,
            .order_item-id,
            .order_item-gun_num {
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-bottom: 5px;
            }

            .order_item-site {
                font-weight: bold;
            }

            .icon {
                font-size: 18px;
                margin-right: 5px;
            }
        }

        .order_item-cost {
            padding-top: 5px;
            text-align: right;

            .order_item-count {
                margin-top: 5px;
                color: #969799;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/beilin/CommodityCard.vue